/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useState } from 'react';
// redux
import {useDispatch} from 'react-redux';
import { cancelImport } from '../../../../../../state/thunks/commenting';
// material
import { SubPage, Copy, BodyCopy, CTAs, Button, displayModal, displayErrorMessage } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './cancelimportpopup_styles';

/* ========== ~~~~~~~~~~ CANCEL IMPORT POPUP~~~~~~~~~~ ========== */
const CancelImportPopup = props => {
  const dispatch = useDispatch();

  const { id, vendor, integrationId, onCancel } = props
  const [isProcessing, setIsProcessing] = useState(false)

  const handleNo = () => dispatch(displayModal(false));

  const handleYes = useCallback(async() => {
    setIsProcessing(true)
    const response = await dispatch(cancelImport({id, vendor, integrationId}))
    if(response.payload || response.status === 200 || response === true) {
        dispatch(displayModal(false))
        if(onCancel) onCancel()
    } 
    setIsProcessing(false)
  }, [dispatch])

  return (
      <SubPage name={`cancelimportpopup`} klass={props.classes.cancelimportpopup}>
          <Copy name={`cancelimportpopup`}>
              <BodyCopy>{`Are you sure you want to cancel this import?`}</BodyCopy>
          </Copy>
          <CTAs name={`ctas`} >
              <Button type={`action`} handleClick={handleNo} variant={`normal`} name={`no`} text={`No`} />
              <Button type={'action'} handleClick={handleYes} variant={`delete`} name={`yes`} text={`Yes`} operation={'delete'} processing={isProcessing} processingText={'Cancelling..'} />
          </CTAs>
      </SubPage>
  );
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CancelImportPopup);
